export default "__VITE_ASSET__CGPy4tOq__"